/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import type { ThemeType } from "@packages/ui";
import { Container, HallowImage, Text } from "@packages/ui";

import { ParishSearch } from "./ParishSearch";

const cssContainer: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
  minHeight: "80vh",
  paddingBottom: theme.spacing.xl,
  paddingInline: theme.spacing.ms,
  paddingTop: theme.spacing.none,
  rowGap: theme.spacing.l,
  textAlign: "center",
});

const cssImage: Interpolation<ThemeType> = (theme) => ({
  borderRadius: theme.radius.ms,
  display: "block",
  marginBlock: 0,
  marginInline: "auto",
  maxWidth: theme.spacing.maxWidthWithPaddingXS,
  width: theme.spacing.full,
});

const cssImageContainer: Interpolation<ThemeType> = (theme) => ({
  aspectRatio: "157 / 110",
  maxWidth: theme.spacing.maxWidthWithPaddingXS,
  width: theme.spacing.full,
});

export const ParishClient = () => {
  const t = useTranslations();

  return (
    <Container maxWidth size="s" css={cssContainer}>
      <Text as="h1" type="headline" size="s">
        {t("web_parish_join_your_church")}
      </Text>
      <div css={cssImageContainer}>
        <HallowImage
          alt=""
          size="l"
          src={{
            small: "https://images.hallow.app/covers/920_s.webp",
            medium: "https://images.hallow.app/covers/920_m.webp",
            large: "https://images.hallow.app/covers/920_l.webp",
            fallback: "https://images.hallow.app/covers/920_l.png",
          }}
          loading="eager"
          css={cssImage}
        />
      </div>
      <Text as="p" type="headline" size="s">
        {t("web_parish_search_and_connect")}
      </Text>
      <ParishSearch />
    </Container>
  );
};
